import React from "react";
import { styled } from "styled-components";
import { InputText } from "../Text";
import { Check } from "../../icons";
import Colors from "../../styles/Colors";
import idGenerator from "../../utils/idGenerator";
const CheckboxLabel = styled.label `
  position: relative;
  display: flex;
  align-items: flex-start;
  cursor: pointer;

  &:hover > input,
  &:hover > input:checked {
    box-shadow: inset 0 0 0 1px ${Colors.LIGHT_RED_2024},
      0 0 0 4px ${Colors.LIGHT_RED_2024};
  }

  > input {
    flex-shrink: 0;
    appearance: none;
    border: none;
    padding: 0;
    margin: 0 0.5rem 0 0;
    width: 1.5rem;
    height: 1.5rem;
    box-shadow: inset 0 0 0 1px ${Colors.GRAY};
    border-radius: 0.25rem;
    cursor: pointer;

    + span {
      margin-top: 1px;
    }

    ~ span > svg {
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      visibility: hidden;
    }

    &:focus {
      outline: none;
    }

    &:checked {
      background-color: ${Colors.LIGHT_RED_2024};
      box-shadow: inset 0 0 0 1px ${Colors.LIGHT_RED_2024};

      ~ span > svg {
        visibility: visible;
      }
    }
  }
`;
export const Checkbox = ({ label, ...props }) => {
    const [inputId] = React.useState(() => props.id ?? idGenerator("fjordline-radio-"));
    return (React.createElement(CheckboxLabel, { htmlFor: inputId },
        React.createElement("input", { type: "checkbox", id: inputId, ...props }),
        React.createElement(InputText, null, label),
        React.createElement("span", { "aria-hidden": "true" },
            React.createElement(Check, { width: 16, height: 16 }))));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map